import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import moment from 'moment'

import "../src/design/app.scss";
import 'cropperjs/dist/cropper.css';

import store from '@/state/store'

import App from './App.vue'

import { initFirebaseBackend } from './authUtils'
import i18n from './i18n'

import { configureFakeBackend } from './helpers/fake-backend';

import tinymce from 'vue-tinymce-editor'

import axios from "axios";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  configureFakeBackend();
}

Vue.prototype.$axios = axios.create({
  // baseURL: 'https://api.brightideainfotech.tech/',
  // baseURL: 'http://127.0.0.1:8000/',
  //baseURL: 'https://services.medicinohealthtech.in/'
    // baseURL: 'https://services.dev.medicinohealthtech.in/'
      baseURL: 'https://staging.medicino.in/',

});
//  Vue.prototype.$image_url = 'https://api.brightideainfotech.tech/storage/';
// Vue.prototype.$image_url = 'http://127.0.0.1:8000/storage/app/public/';
//Vue.prototype.$image_url = 'https://services.medicinohealthtech.in/storage/';
// Vue.prototype.$image_url = 'https://services.dev.medicinohealthtech.in/storage/';
Vue.prototype.$image_url = 'https://staging.medicino.in/storage/';

// Redirect to login when session is missing or expired (401)
Vue.prototype.$axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('medicino_admin')
      if (router.currentRoute.name !== 'login') {
        router.push({ name: 'login' })
      }
    }
    return Promise.reject(error)
  }
)



//********* filters starts ************//

Vue.filter("formatDateTime", function (datetime) {
  if (datetime) {
    //alert(datetime);
    return moment.utc(datetime).format("DD MMM YYYY, hh:mm A");
  }
});

Vue.filter("formatDate", function (date) {
  if (date) {
    return moment(date).format("DD MMM YYYY");
  }
});
Vue.filter("formatDate2", function (date) {
  if (date) {
    return moment(date).format("DD-MM-YYYY");
  }
});

Vue.filter("formatTimeOnly", function (datetime) {
  if (datetime) {
    return moment(datetime).format("hh:mm A");
  }
});

Vue.filter('formatTime', function(time) {
  if(time) {
    var datetime = '2022-02-08 ' + time;
    return moment.utc(datetime).format('hh:mm A');
  }
});

Vue.filter("chatTime", function (datetime) {

  var today = moment().format("YYYY-MM-DD");
  //var yesterday = moment().subtract(1, 'days').format("YYYY-MM-DD");
  var date = moment(datetime).format("YYYY-MM-DD");

  if (date === today) {
    return moment(datetime).format("hh:mm A"); 

  // } else if(date == yesterday) {
  //   return moment(datetime).format("hh:mm A");

  } else {
    //alert(datetime);
    return moment(datetime).format("DD MMM YYYY, hh:mm A");
  }
});

Vue.filter('excerpt', function(text, length) {
  if(text) {
    return text.length > length ? text.slice(0, length) + '...' : text;
  }
})

//********* filters ends ************//

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
//Vue.use(VueSweetalert2);
Vue.use(VueSweetalert2, {
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  toast: true,
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBfNQlPkpdeMTVg6VKLvEF3OF8WgDM_wUY',//BrightIdea key
    // key: 'AIzaSyBCN42iAP4i3_QUcP9HRALRmCuZtA1iLEM',//Old medicino key
    // key: 'AIzaSyDFSyZhayfNWiFj0zdROZO7zi4Od5WiER0', //Medchoice Key

    
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
